export class KlaviyoStarRatingElement extends HTMLElement {
  private observer: MutationObserver | null = null
  private reviewCountSpan: HTMLSpanElement | null = null

  connectedCallback() {
    this.render()
    this.observeKlaviyoWidget()
  }

  disconnectedCallback() {
    this.cleanup()
  }

  private render() {
    const productId = this.getAttribute('product-id') || ''
    const productTitle = this.getAttribute('product-title') || ''
    const productType = this.getAttribute('product-type') || ''

    this.innerHTML = `
      <div class="klaviyo-star-rating-container flex flex-nowrap items-center gap-x-0.25">
        <div
          class="klaviyo-star-rating-widget flex"
          slot="productReviews"
          data-id="${productId}"
          data-product-title="${productTitle}"
          data-product-type="${productType}"
        ></div>
        <span class="custom-star-rating text-xs font-semibold text-line"></span>
      </div>
    `

    this.reviewCountSpan = this.querySelector('.custom-star-rating')
  }

  private observeKlaviyoWidget() {
    const targetNode = this.querySelector('.klaviyo-star-rating-widget')
    if (!targetNode) return

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const reviewLabel = targetNode.querySelector('.kl_reviews__star_rating_widget__label')
          if (reviewLabel && this.reviewCountSpan) {
            const originalText = reviewLabel.textContent?.trim() || ''
            const count = originalText.replace('reviews', '').trim()
            this.reviewCountSpan.textContent = `(${count})`
            this.cleanup()
          }
        }
      })
    })

    this.observer.observe(targetNode, { childList: true, subtree: true })
  }

  private cleanup() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}
